module.exports = __webpack_public_path__ + "img/glass.92681626.jpg";